import {useCallback} from "react";
import {useSelector} from "react-redux";
import {getClientAllowedEmailFqdns, getPermission} from "../redux/appEnvironment.selector";
import {PermissionsEnum} from "../redux/models/appEnvironment";
import {User} from "components/admin/user/UserManager.types";

export const useGetPermUserCanEdit = () => {
  const getPermissionSelector = useSelector(getPermission)
  const userCanManageAdvancedFeature = getPermissionSelector(PermissionsEnum.userCanManageAdvancedFeature)
  const clientAllowedEmailFqdns = useSelector(getClientAllowedEmailFqdns) as string[]

  return useCallback((user?: User) => userCanManageAdvancedFeature
    || (user?.email !== undefined && clientAllowedEmailFqdns.includes(user.email.substr(user.email.indexOf('@') + 1))), [clientAllowedEmailFqdns, userCanManageAdvancedFeature])
}
